import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { getRecipientForDeviation } from '../../../utils';
import CoreBadgeList from '../../CoreBadgeList';
var DeviationCoreBadgeList = function (_a) {
    var _b;
    var deviation = _a.deviation, className = _a.className;
    return (React.createElement(CoreBadgeList, { className: className, badges: ((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.awardedBadges) || [], recipient: getRecipientForDeviation(deviation), notificationQueueName: getDeviationNotificationQueue(deviation), biData: BiData({
            evid: 323,
            sectionname: 'deviation',
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
        }) }));
};
DeviationCoreBadgeList.displayName = 'DeviationCoreBadgeList';
export default DeviationCoreBadgeList;
//# sourceMappingURL=DeviationCoreBadgeList.js.map